import { CONTACT, buildWhatsAppUrl } from '../../data/site';
import { MEDICAL_NEGLIGENCE_WHATSAPP_MESSAGE } from '../../data/medicalNegligenceLanding';
import { Icon } from '../Icon';

type Props = {
  analyticsPrefix: string;
  theme?: 'light' | 'dark';
  showPhoneNumber?: boolean;
  compact?: boolean;
  className?: string;
};

export function CampaignContactActions({
  analyticsPrefix,
  theme = 'dark',
  showPhoneNumber = false,
  compact = false,
  className = '',
}: Props) {
  const whatsappUrl = buildWhatsAppUrl(MEDICAL_NEGLIGENCE_WHATSAPP_MESSAGE);

  return (
    <div className={`campaign-contact-actions campaign-contact-actions--${theme}${compact ? ' campaign-contact-actions--compact' : ''} ${className}`.trim()}>
      <a
        className="campaign-button campaign-button--gold"
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-analytics-event={`${analyticsPrefix}_whatsapp`}
      >
        <Icon name="whatsapp" size={20} />
        Cuéntanos tu caso
      </a>
      <a
        className={`campaign-button ${theme === 'dark' ? 'campaign-button--outline' : 'campaign-button--outline-dark'}`}
        href={`tel:+${CONTACT.phoneInternational}`}
        data-analytics-event={`${analyticsPrefix}_phone`}
      >
        <Icon name="phone" size={19} />
        {showPhoneNumber ? CONTACT.phoneDisplay : 'Llamar'}
      </a>
    </div>
  );
}
